import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import Cookies from 'js-cookie';
import cache from 'memory-cache';
import axios from './../utils/axiosConfig';
import Modal from './Test/WindowSwitch/SwitchModal';
import { Grid } from '@material-ui/core';
import {LoaderProcessingOutlined} from './LoaderProcessing';
import useUnload from './UseUnload';
import modalHandler from '../utils/modalHandler';
const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

// const formattedDate = date.toLocaleDateString('en-GB', {
//   day: 'numeric', month: 'short', year: 'numeric'
// }).replace(/ /g, '-');


const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);


const useStyles = makeStyles({
  table: {
    minWidth: 340,
  
  },
  root: {
    background:"#fff"
    
  },
  tableCell: {
    paddingRight: 4,
    paddingLeft: 5
  }
  
});

export default function CustomizedTables(props) {
  const classes = useStyles();
  const {tableData, status, typeButton, setModal, setTestData,examId, setExamId,buttonName} = props;  
  let token = Cookies.get('token');
  const [msgModal, setMsgModal] = React.useState(false);
  
  const [showModel, setModelShow] = React.useState(false);
  const [ind, setInd] = React.useState(0);
  const [loading,setLoading] = React.useState({index:"",status:false,name:""});
  const [resumeLoader,setResumeLoader] = React.useState({index:"",status:false,name:""});
  const [messageModal,setMessageModal] = React.useState('');
  const [message,setMessage] = React.useState('');
  // const [showtb, setShowtb] = React.useState(tableData === undefined ? false : true);
  

  if(tableData['tableHeaders'] !== undefined){
  //  tableData['001']!==undefined?setInd(tableData['001'].length):setInd(0) ;
}

React.useEffect(()=>{
  tableData['001']!==undefined?setInd(tableData['001'].length):setInd(0) ;
 // setInd(tableData['001'].length );
 
})

window.onunload = function (event){ // onload event handler
  event.preventDefault();
  window.localStorage.removeItem(examId);
}

  return (

    <Grid item xs={12}>
    
    <Paper className={classes.root}>
    {/* #8080801f */}
    <div className="listing_div" >
        <div className="list_head" >
  <p>
  {
              tableData && tableData['tableHeaders'] !== undefined ? 
              tableData['tableHeaders'].split(',').map((item,index) => {
          
                return ( <span  style={{lineHeight:'2'}} className={index === 0? "srno": index === 1?"name":index === 2?"status":index === 3?"time":index === 4?"list_action-t":""} key={index}>{item}</span>)
              })
              :
              <></>
            }
  </p>
</div>
     {
            tableData['001'] !== undefined ? 
              tableData['001'].map((row, index) => {
                return(
                  <div key={index} className={index % 2 != 0 ? "list_even list_name2" : "list_odd list_name2"  }  >
                       <div key={index} className="list_detail">
                       <span className="srno">{index+1}</span> 
                     
                  
                       <span className="name">{row.examName}</span>
                       <span className="status"><strong className="viewInMob">Status - </strong>IN PROGRESS</span> 
                       <span className="time">{new Date(row.date).toLocaleDateString('en-GB', {day: 'numeric', month: 'short', year: 'numeric'}).replace(/ /g, '-')+"   "}{new Date(row.date).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit',hour12:true})}</span>
                       </div>
                       <div className="list_action-t" >
                       
                       {resumeLoader.status && resumeLoader.index === index && resumeLoader.name === `resume_${buttonName}_${index}` ? <LoaderProcessingOutlined /> : 
                        <Button variant="outlined" name ={`resume_${buttonName}_${index}`} style={{ top: "-5px" }} color="primary" onClick={(e) => modalHandler(row, index,e,props,setLoading,setModelShow,setMsgModal,setResumeLoader,setMessageModal,setMessage)}>
                          Resume
                        </Button>
                       } 
                    </div>
                  </div>
                );
              })
            :
            <></>
          }
          {
            tableData['000'] !== undefined ? 
              tableData['000'].map((row, index) => {
                return(
                  
                  <div key={index} className={(ind+index) % 2 != 0 ? "list_even list_name2" : "list_odd list_name2"   }>
                  <div className="list_detail">
                  <span className="srno">{ind+index+1}</span> 
                
             
                  <span className="name">{row.examName}</span>
                  <span className="status"><strong className="viewInMob">Status - </strong>NOT STARTED</span> 
                  <span className="time">{new Date(row.date).toLocaleDateString('en-GB', {day: 'numeric', month: 'short', year: 'numeric',time:'numeric'}).replace(/ /g, '-')+"   "} {new Date(row.date).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit',hour12:true})}</span>
                  </div>
                    <div className="list_action-t">
                      {
                         loading.status && loading.index === index && loading.name === `TakeTest_${buttonName}_${index}` ? 
                          <LoaderProcessingOutlined />
                          :
                           <Button name ={`TakeTest_${buttonName}_${index}`} disabled={new Date(row.date) > new Date()} variant="outlined" style={{ top: "-5px" }} color="primary" onClick={(e) => modalHandler(row, index,e,props,setLoading,setModelShow,setMsgModal,setResumeLoader,setMessageModal,setMessage)}>
                             {`Take ${typeButton === 'Survey' ? 'Survey' : 'Test'} Online`}
                           </Button> 
                      } 
                    </div>
             </div>
                );
              })
            :
            <></>
          }
{
            tableData && tableData[Object.keys(tableData)[0]] === undefined && 
            <>
            <div className="list_odd list_name" style={{padding:'0px',lineHeight:'3'}}  >
            <div className="list_detail" style={{textAlign:'center'}}>
            <span style={{fontSize:'15px',fontWeight:'bold'}}>{typeButton === 'Feedback' ? 'No Pending Feedback' : typeButton === 'Survey' ? 'No Pending Survey' : typeButton === 'WorkFlow' ? 'No WorkFlow' : 'No Pending Tests'}</span> 
            </div>
            </div>
            </>
}
        
      </div>
      {/* <Table className={classes.table} aria-label="customized table">
        <TableHead className="thead-dark">
          <TableRow>
            {
              tableData['tableHeaders'] !== undefined ? 
              tableData['tableHeaders'].split(',').map((item,index) => {
                return (<StyledTableCell key={index}>{item}</StyledTableCell>)
              })
              :
              <></>
            }
           
 
          </TableRow>
        </TableHead>
        <TableBody>
          {
            tableData['001'] !== undefined ? 
              tableData['001'].map((row, index) => {
                return(
                  <StyledTableRow key={`${'001'}_${index}`}>
                    <StyledTableCell  component="th" scope="row">
                      {index+1}
                    </StyledTableCell>
                    <StyledTableCell >{row.examName}</StyledTableCell>
                    <StyledTableCell >IN PROGRESS</StyledTableCell>
                    <StyledTableCell >{row.date}</StyledTableCell>
                    <StyledTableCell>
                      <Button variant="outlined" color="primary" onClick={() => modalHandler(row)}>
                      Resume
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            :
            <></>
          }
          {
            tableData['000'] !== undefined ? 
              tableData['000'].map((row, index) => {
                return(
                  <StyledTableRow key={`${'000'}_${index}`}>
                    <StyledTableCell  component="th" scope="row">
                      {ind+index+1}
                    </StyledTableCell>
                    <StyledTableCell >{row.examName}</StyledTableCell>
                    <StyledTableCell >NOT STARTED</StyledTableCell>
                    <StyledTableCell >{row.date}</StyledTableCell>
                    <StyledTableCell>
                      <Button variant="outlined" color="primary" onClick={() => modalHandler(row)}>
                      {`Take ${typeButton === 'Survey' ? 'Survey' : 'Test'} Online`}
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            :
            <></>
          }
          
        </TableBody>
      </Table> */}
        {msgModal ?
          <Modal headerMessage={messageModal} message= {message ? message : ''} showModel={showModel} />
          : <>    </>}
 </Paper>  
 </Grid>
  );
}